var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.bread.length>0)?_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.bread),function(item,index){return _c('el-breadcrumb-item',{key:index,class:item.class,nativeOn:{"click":function($event){return _vm.breadLink(item)}}},[_vm._v(_vm._s(item.title))])}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }